import React, { useState } from "react";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import Ornament from "@/components/Ornament";
import FancyTitle from "@/components/FancyTitle";
import { Link } from "react-router-dom";
import { X } from "lucide-react";

// House photographs (mix of rooms, gardens and details)
const IMAGES = [
  { src: "/img/music-room.jpg" },
  { src: "/img/new2-000042430025.jpg" },
  { src: "/img/photo-530009.jpg" },
  { src: "/img/new2-20260921-192036.jpg" },
  { src: "/img/photo-002.jpg" },
  { src: "/img/new-011.jpg" },
  { src: "/img/photo-530027.jpg" },
  { src: "/img/new2-000042430023.jpg" },
  { src: "/img/star-arch.jpg" },
  { src: "/img/new2-20260921-173004.jpg" },
  { src: "/img/garden-roses.jpg" },
  { src: "/img/new-wa0030.jpg" },
  { src: "/img/new2-000042440006.jpg" },
  { src: "/img/new-002.jpg" },
  { src: "/img/photo-004.jpg" },
  { src: "/img/photo-540012.jpg" },
  { src: "/img/new2-20260922-185259.jpg" },
  { src: "/img/photo-530020.jpg" },
  { src: "/img/new-006.jpg" },
  { src: "/img/new2-000042430038.jpg" },
  { src: "/img/garden-table.jpg" },
  { src: "/img/desk-2.jpg" },
  { src: "/img/new-530001.jpg" },
  { src: "/img/photo-009.jpg" },
  { src: "/img/photo-010.jpg" },
];

export default function Gallery() {
  const [active, setActive] = useState(null);

  return (
    <>
      <Navigation />

      <section className="max-w-6xl mx-auto px-6 md:px-12 pt-16 md:pt-24 pb-8 text-center">
        <FancyTitle as="h1" className="press-title text-4xl sm:text-5xl lg:text-6xl text-ink mt-4 uppercase tracking-[0.28em] sm:tracking-[0.34em]">
          Gallery
        </FancyTitle>
        <Ornament />
      </section>

      <section className="max-w-7xl mx-auto px-6 md:px-12 pb-24" data-testid="gallery-grid">
        <div className="columns-1 sm:columns-2 lg:columns-3 gap-4">
          {IMAGES.map((img, i) => (
            <button
              key={i}
              type="button"
              onClick={() => setActive(i)}
              className="relative block w-full overflow-hidden group mb-4 break-inside-avoid"
              data-testid={`gallery-item-${i}`}
            >
              <img
                src={img.src}
                alt=""
                loading="lazy"
                className="block w-full h-auto transition-transform duration-[800ms] group-hover:scale-[1.04]"
              />
              <span className="absolute inset-0 bg-ink/0 group-hover:bg-ink/15 transition-colors" />
            </button>
          ))}
        </div>

        <div className="text-center mt-16 border-t border-ink/20 pt-10">
          <p className="font-display italic text-ink/70 text-lg">
            More to come.
          </p>
          <Link
            to="/enquire"
            className="inline-block mt-6 bg-burgundy text-parchment px-8 py-4 font-sans text-[0.78rem] uppercase tracking-[0.28em] hover:bg-ink transition-colors"
            data-testid="gallery-enquire-cta"
          >
            Enquire about a stay
          </Link>
        </div>
      </section>

      {/* LIGHTBOX */}
      {active !== null && (
        <div
          className="fixed inset-0 z-[100] bg-ink flex items-center justify-center p-4 md:p-12 animate-in fade-in"
          onClick={() => setActive(null)}
          data-testid="gallery-lightbox"
        >
          <button
            className="absolute top-6 right-6 text-parchment/70 hover:text-parchment"
            onClick={() => setActive(null)}
            data-testid="lightbox-close"
            aria-label="Close"
          >
            <X className="w-7 h-7" strokeWidth={1.5} />
          </button>
          <figure className="max-w-6xl max-h-full flex flex-col items-center" onClick={(e) => e.stopPropagation()}>
            <img
              src={IMAGES[active].src}
              alt=""
              className="max-h-[80vh] w-auto object-contain"
            />
            <div className="mt-4 flex gap-6">
              <button
                className="font-sans text-[0.7rem] uppercase tracking-[0.22em] text-parchment/70 hover:text-parchment"
                onClick={() => setActive((active - 1 + IMAGES.length) % IMAGES.length)}
                data-testid="lightbox-prev"
              >
                ← Previous
              </button>
              <button
                className="font-sans text-[0.7rem] uppercase tracking-[0.22em] text-parchment/70 hover:text-parchment"
                onClick={() => setActive((active + 1) % IMAGES.length)}
                data-testid="lightbox-next"
              >
                Next →
              </button>
            </div>
          </figure>
        </div>
      )}

      <Footer />
    </>
  );
}
